import {Injectable} from '@angular/core';
import {Store} from '@ngrx/store';
import {BehaviorSubject} from 'rxjs';
import {delay} from 'rxjs/operators';
import {updateUserTrainingProgress} from './e-learning.actions';
import {ELearningSlice} from './e-learning.reducer';

@Injectable()
export class SlideUtilService {
  private readonly _navbarState = new BehaviorSubject<boolean>(true);
  readonly navbarShown = this._navbarState.pipe(delay(0));

  constructor(private readonly _store: Store<ELearningSlice>) {}

  setNavbar(shown: boolean) {
    this._navbarState.next(shown);
  }

  trackProgress(slug: string, slideId: string) {
    this._store.dispatch(
      updateUserTrainingProgress({
        slug,
        slideId,
      }),
    );
  }
}
